import React, { useEffect } from "react";
import axios from "axios";
import * as apiMethods from "../res/apiMethods.js";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import "date-fns";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import Sidebar from "../components/Sidebar";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: 8,
    minWidth: "70%",
  },
  selectEmpty: {
    marginTop: 16,
  },
}));

const Search = () => {
  const classes = useStyles(); // ✅ Usar los estilos aquí

  const [props, setProps] = React.useState({
    criteria: [],
    entity: "",
    nameSearched: false,
    clientsQuery: [],
    selectedCriteria: "",
    search: "",
  });

  const setState = (value, cb) => {
    setProps((prevState) => ({ ...prevState, ...value }));
    if (cb) {
      if (typeof cb === "function") cb();
    }
  };

  const handleChange = (prop) => (event) => {
    setProps({ ...props, [prop]: event.target.value });
  };

  useEffect(() => {
    console.log("useEffect ejecutándose"); // ← Debug
    console.log("URL:", window.location.href); // ← Debug
    
    if (window.location.href.search("client") !== -1) {
      console.log("Es cliente"); // ← Debug
      setState({
        criteria: [
          { slug: "document", text: "Documento del cliente" },
          { slug: "name", text: "Nombre del cliente" },
        ],
        entity: "client",
      });
    } else {
      console.log("Es crédito"); // ← Debug
      setState({
        criteria: [
          { slug: "document", text: "Documento del cliente" },
          { slug: "id", text: "Identificador del crédito" },
          { slug: "financialCode", text: "Código de entidad financiera" },
        ],
        entity: "credit",
      });
    }
  }, []);

  const renderDetailsButton = (params) => {
    return (
      <strong>
        <Button
          variant="contained"
          sx={{ backgroundColor: 'primary', '&:hover': { backgroundColor: 'rgb(0, 163, 27)' } }}
          size="small"
          onClick={() => {
            axios
              .get(apiMethods.GET_CLIENTE_DOCUMENTO + params.row.documento)
              .then((response) => {
                if (response.data.code != 0) {
                  toast.error("Cliente no encontrado");
                } else {
                  window.location.href = `/clients/${params.row.documento}`;
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }}
        >
          Abrir
        </Button>
      </strong>
    );
  };

  const clientsColumns = [
    { field: "documento", headerName: "Documento del cliente", width: 250 },
    { field: "tipoDocumento", headerName: "Tipo documento", width: 250 },
    { field: "nombre", headerName: "Nombre", width: 250 },
    {
      field: "accion",
      headerName: "Acción",
      width: 150,
      renderCell: renderDetailsButton,
    },
  ];

  const search = async (formData) => {
    let decodedPayload = JSON.parse(
      atob(window.sessionStorage.getItem("localToken").split(".")[1])
    );
    let localCredits = [];
    let localNombre;

    if (decodedPayload.role === 4) {
      let creditsResponse = await axios.get(
        apiMethods.GET_CLIENTE_DOCUMENTO + decodedPayload.username
      );
      localCredits = creditsResponse.data.client.creditos;
      localNombre = creditsResponse.data.client.nombre;
    }

    if (props.entity === "client") {
      switch (formData.selectedCriteria) {
        case "document":
          if (
            formData.search != decodedPayload.username &&
            decodedPayload.roleId == 4
          ) {
            toast.error("No tiene suficientes privilegios");
          } else {
            axios
              .get(apiMethods.GET_CLIENTE_DOCUMENTO + formData.search)
              .then((response) => {
                if (response.data.code != 0) {
                  toast.error("Cliente no encontrado");
                } else {
                  window.location.href = `/clients/${formData.search}`;
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          break;
        case "name":
          if (formData.search != localNombre && decodedPayload.roleId == 4) {
            toast.error("No tiene suficientes privilegios");
          } else {
            axios
              .get(apiMethods.GET_CLIENTE_NOMBRE + formData.search)
              .then((response) => {
                if (!response.data.clients[0]) {
                  toast.error("Cliente no encontrado");
                } else {
                  setState({
                    clientsQuery: response.data.clients,
                    nameSearched: true,
                  });
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          break;
      }
    } else {
      switch (formData.selectedCriteria) {
        case "document":
          if (
            formData.search != decodedPayload.username &&
            decodedPayload.roleId == 4
          ) {
            toast.error("No tiene suficientes privilegios");
          } else {
            axios
              .get(apiMethods.GET_CLIENTE_DOCUMENTO + formData.search)
              .then((response) => {
                if (response.data.code != 0) {
                  toast.error("El documento no existe");
                } else {
                  window.location.href = `/clients/${formData.search}`;
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          break;
        case "id":
          if (
            !localCredits.find((element) => element == formData.search) &&
            decodedPayload.roleId == 4
          ) {
            toast.error("No tiene suficientes privilegios");
          } else {
            axios
              .get(apiMethods.GET_CREDITO_ID + formData.search)
              .then((response) => {
                if (response.data.code != 0) {
                  toast.error("Crédito no encontrado");
                } else {
                  window.sessionStorage.setItem(
                    "localDocument",
                    formData.search
                  );
                  window.location.href = `/credits/${formData.search}`;
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          break;
        case "name":
          if (formData.search != localNombre && decodedPayload.roleId == 4) {
            toast.error("No tiene suficientes privilegios");
          } else {
            axios
              .get(apiMethods.GET_CLIENTE_NOMBRE + formData.search)
              .then((response) => {
                if (
                  response.data.code != 0 ||
                  response.data.clients.length == 0
                ) {
                  toast.error("Cliente no encontrado");
                } else {
                  setState({
                    clientsQuery: response.data.clients,
                    nameSearched: true,
                  });
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          break;
        case "financialCode":
          if (
            !localCredits.find((element) => element == formData.search) &&
            decodedPayload.roleId == 4
          ) {
            toast.error("No tiene suficientes privilegios");
          } else {
            axios
              .get(apiMethods.GET_CREDITO_FINANCIAL_CODE + formData.search)
              .then((response) => {
                if (response.data.credits) {
                  window.sessionStorage.setItem(
                    "localDocument",
                    response.data.credits.id
                  );
                  window.location.href = `/credits/${response.data.credits.id}`;
                } else {
                  toast.error("Crédito no encontrado");
                }
              })
              .catch((error) => {
                console.log(error);
              });
          }
          break;
      }
    }
  };

  const onError = (errors, e) => {
    for (let error in errors) {
      toast.error(errors[error].message);
    }
  };

  const {
    control,
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();

  return window.sessionStorage.getItem("localToken") ? (
    <React.Fragment>
      <ToastContainer />
      <div style={{ display: "grid", gridTemplateColumns: "15% 85%" }}>
        <Sidebar />
        <div className="card" style={{ width: "100%" }}>
          <div
            style={{
              fontSize: "15pt",
              fontWeight: "500",
              marginBottom: "1rem",
              marginTop: "1rem",
              marginLeft: "1rem",
            }}
          >
            {props.entity == "credit"
              ? "Búsqueda créditos"
              : "Búsqueda clientes"}
          </div>
          <form onSubmit={handleSubmit(search, onError)}>
            <div
              style={{ display: "grid", gridTemplateColumns: "35% 30% 8rem" }}
            >
              <div className="create-credit-input-row">
                <FormControl className={classes.formControl}>
                  <InputLabel>Criterio de búsqueda</InputLabel>
                  <Select
                  label="Criterio de búsqueda"
                  defaultValue="document"
                  onChange={(e) => {
                    handleChange("selectedCriteria");
                  }}
                  onClick={(e) => {
                    console.log(e);
                    setState({ nameSearched: false });
                  }}
                  required
                  {...register("selectedCriteria")}
                  style={{ textAlign: "left" }}>
                  {props.criteria.map((criteria) => {
                    return (
                      <MenuItem value={criteria.slug}>{criteria.text}</MenuItem>
                    );
                  })}
                </Select>
                </FormControl>
              </div>
              <div className="create-credit-input-row">
                <TextField
                  required
                  onChange={handleChange("search")}
                  className="create-credit-input"
                  label="Búsqueda"
                  {...register("search")}
                />
              </div>
              <div className="create-credit-input-row">
                <Button variant="contained" color="primary" type="submit">
                  Buscar
                </Button>
              </div>
            </div>
            {props.entity == "client" && props.nameSearched == true && (
              <div style={{ height: 300, width: "100%" }}>
                <DataGrid
                  rows={props.clientsQuery}
                  columns={clientsColumns}
                  pageSize={5}
                  getRowId={(row) => row._id}
                  rowsPerPageOptions={[5, 10]}
                  disableSelectionOnClick
                />
              </div>
            )}
          </form>
        </div>
      </div>
    </React.Fragment>
  ) : (
    <div>Acceso denegado</div>
  );
};

export default Search;